import { Scheduler } from "https://cdn.kernvalley.us/js/std-js/Scheduler.js";

if (!('scheduler' in globalThis)) {
  globalThis.scheduler = new Scheduler();
}